import { InjectionToken } from '@angular/core';

export const DEPOSIT_FORM_DIALOG_DATA = new InjectionToken<any>('DEPOSIT_FORM_DIALOG_DATA');
